import _ from 'lodash';

const getters = {
  history: (state) => _.orderBy(state.history, 'time', 'desc'),
  lastHistory: (state) => state.lastHistory[0],
};
export default getters;
